import React from "react";
import { Eye, CheckCircle, XCircle, Trash2 } from "lucide-react";
import { UserAssignment } from "../../../lib/types/adminProjects";

interface AssignmentDropdownMenuProps {
  assignment: UserAssignment | null;
  menuPosition: { top: number; left: number } | null;
  onClose: () => void;
  onAction: (type: string) => void;
}

const AssignmentDropdownMenu: React.FC<AssignmentDropdownMenuProps> = ({
  assignment,
  menuPosition,
  onClose,
  onAction,
}) => {
  if (!assignment || !menuPosition) return null;

  return (
    <>
      <div className="fixed inset-0 z-[100]" onClick={onClose} />
      <div
        className="fixed w-48 bg-white rounded-xl border border-gray-200 shadow-lg z-[101] py-1"
        style={{
          top: menuPosition.top,
          left: Math.max(8, menuPosition.left),
        }}
      >
        <button
          onClick={() => onAction("view")}
          className="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
        >
          <Eye className="w-4 h-4" />
          View Details
        </button>

        {assignment.status === "pending" && (
          <>
            <button
              onClick={() => onAction("approve")}
              className="w-full flex items-center gap-2 px-4 py-2 text-sm text-emerald-600 hover:bg-emerald-50"
            >
              <CheckCircle className="w-4 h-4" />
              Approve
            </button>
            <button
              onClick={() => onAction("reject")}
              className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50"
            >
              <XCircle className="w-4 h-4" />
              Reject
            </button>
          </>
        )}

        {assignment.status === "approved" && (
          <button
            onClick={() => onAction("activate")}
            className="w-full flex items-center gap-2 px-4 py-2 text-sm text-blue-600 hover:bg-blue-50"
          >
            <CheckCircle className="w-4 h-4" />
            Mark Active
          </button>
        )}

        {assignment.status === "active" && (
          <>
            <button
              onClick={() => onAction("complete")}
              className="w-full flex items-center gap-2 px-4 py-2 text-sm text-purple-600 hover:bg-purple-50"
            >
              <CheckCircle className="w-4 h-4" />
              Mark Completed
            </button>
            <button
              onClick={() => onAction("terminate")}
              className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50"
            >
              <XCircle className="w-4 h-4" />
              Terminate
            </button>
          </>
        )}

        {["assigned", "rejected"].includes(assignment.status) && (
          <>
            <hr className="my-1 border-gray-100" />
            <button
              onClick={() => onAction("unassign")}
              className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50"
            >
              <Trash2 className="w-4 h-4" />
              Unassign
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default AssignmentDropdownMenu;
